enum CommentTaskType {
    PreService = 1,
    PostService = 2,
    Recurrence = 3
}

export default CommentTaskType;